import { render, staticRenderFns } from "./InspectAnswer.vue?vue&type=template&id=3ad58810&scoped=true"
import script from "./InspectAnswer.vue?vue&type=script&lang=ts"
export * from "./InspectAnswer.vue?vue&type=script&lang=ts"
import style0 from "./InspectAnswer.vue?vue&type=style&index=0&id=3ad58810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad58810",
  null
  
)

export default component.exports